<template>
	<div class="video-container">
		<video ref="source" class="video-source" v-on="$listeners" autoplay playsinline v-bind="$attrs">
			<source :src="src" type='video/mp4; codecs="avc1.42E01E"' />
		</video>
	</div>
</template>

<script>
export default {
	props: {
		src: {
			type: String,
			required: true,
		},
	},
	async mounted() {
		await this.$refs.source.play();
	},
};
</script>

<style lang="scss">
	.video-container {
		width: 100%;
		height: 100%;
	}

	.video-source {
		width: 100%;
		height: 100%;
		object-fit: cover;
		pointer-events: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/base/Video.vue